export enum BondInsuranceFileContextTypesEnum {
  rentContract = 'RENT_CONTRACT',
  surveyReport = 'SURVEY_REPORT',
  other = 'OTHER'
};

const BondInsuranceFileTranslater: { [key: string]: string } = {
  POLICY: 'Apólice',
  BAIL_INSURANCE_POLICY: 'Apólice Seguro Fiança',
  RETURN_BILL: 'Boleto Devolutivo',
  PORTO_ESSENCIAL_APROVAL_LETTER: 'Carta de Aprovação Porto Essencial',
  PORTO_ESSENCIAL_BUDGETS_OFFERS: 'Carta de aprovação condições',
  RESPONSE_LETTER: 'Carta-resposta',
  PAYMENT_VOUCHER: 'Comprovante de pagamento',
  RENT_CONTRACT: 'Contrato de locação',
  PORTO_ESSENCIAL_APROVAL_LETTER_BUDGETS: 'Cotação Porto Essencial',
  PORTO_ESSENCIAL_APPROVAL_OFFERS: 'Cotação condições',
  QUOTE_DOCUMENT: 'Cotação',
  CORRECTION_ENDORSEMENT: 'Endosso de correção',
  CLAIM_INFORMATION: 'Informativo de sinistro',
  SURVEY_REPORT: 'Laudo de vistoria',
  OTHER: 'Outros',
  DAMAGE_WORKSHEET: 'Planilha de danos',
  PAINTING_WORKSHEET: 'Planilha de pintura',
  CANCELATION_ENDORSEMENT: 'Endosso de cancelamento',
  INSURANCE_CHANGE_TERM: 'Termo cancelamento de troca de seguradora',
  DUPLICATION_POLICY_TERM: 'Termo cancelamento duplicidade de apólice',
  CHANGE_WARRANTY_TERM: 'Termo cancelamento troca de garantia',
  PROPERTY_PURCHASE_TERM: 'Termo compra do imóvel',
  LEASE_ADVANCE_TERM: 'Termo de antecipação de locação',
  LEASE_WITHDRAWL_TERM: 'Termo de desistência de locação',
  DELIVERY_KEYS_TERM: 'Termo de entrega das chaves',
  TERMINATION_TERM: 'Termo de rescisão',
  NO_EXISTENCE_DEBTS_TERM: 'Termo de inexistência de débitos',
  TENANT_CHANGE_TERM: 'Termo de troca de locatário',
};

export const getFileTranslater = (key: string): string => {
  return BondInsuranceFileTranslater[key];
};

export const BondInsuranceFilesAnalysisContext = [
  {
    key: 'APPROVAL_LETTER',
    value: 'Carta de aprovação',
    text: 'Carta de aprovação',
  },
  {
    key: 'BALANCE_SHEET',
    value: 'Balancete',
    text: 'Balancete',
  },
  {
    key: 'BALANCE_SHEET_LAST_3_YEARS_COMPANY_DRE',
    value: 'Balanço patrimonial últimos 3 anos da empresa com DRE',
    text: 'Balanço patrimonial últimos 3 anos da empresa com DRE',
  },
  {
    key: 'BROKERAGE_TRANSFER_LETTER',
    value: 'Carta de tranferência de corretagem',
    text: 'Carta de tranferência de corretagem',
  },
  {
    key: 'SOCIAL_CONTRACT',
    value: 'Contrato social',
    text: 'Contrato social',
  },
  {
    key: 'LESSOR_RG_CNH',
    value: 'Documento de identificação do locador',
    text: 'Documento de identificação do locador',
  },
  {
    key: 'TENANT_RG_CNH',
    value: 'Documento de identificação do locatário',
    text: 'Documento de identificação do locatário',
  },
  {
    key: 'BANK_STATEMENTS_LAST_3_MONTHS',
    value: 'Extratos bancários ultimos 3 meses',
    text: 'Extratos bancários ultimos 3 meses',
  },
  {
    key: 'COMPLEMENTARY_FORM',
    value: 'Formulário complementar',
    text: 'Formulário complementar',
  },
  {
    key: 'PGDAS_GUIDE_LAST_6_MONTHS_PAYMENT',
    value: 'Guia PGDAS dos últimos 6 meses com autenticação de pagamento',
    text: 'Guia PGDAS dos últimos 6 meses com autenticação de pagamento',
  },
  {
    key: 'PAY_SLIP_PAYCHECK',
    value: 'Holerite/Contra-cheque',
    text: 'Holerite/Contra-cheque',
  },
  {
    key: 'INCOME_TAX_WITH_DELIVERY_RECEIPT',
    value: 'Imposto de renda com Recibo de entrega',
    text: 'Imposto de renda com Recibo de entrega',
  },
  {
    key: 'OTHER',
    value: 'Outros',
    text: 'Outros',
  },
  {
    key: 'BILLING_REPORT',
    value: 'Relatório de faturamento',
    text: 'Relatório de faturamento',
  }
];

export const BondInsuranceFilesPolicyContext = [
  {
    key: 'OTHER',
    value: 'Outros',
    text: 'Outros',
  },
  {
    key: 'POLICY',
    value: 'Apólice',
    text: 'Apólice',
  },
  {
    key: 'PORTO_ESSENCIAL_APROVAL_LETTER',
    value: 'Carta de Aprovação Porto Essencial',
    text: 'Carta de Aprovação Porto Essencial',
  },
  {
    key: 'PORTO_ESSENCIAL_BUDGETS_OFFERS',
    value: 'Carta de aprovação condições',
    text: 'Carta de aprovação condições',
  },
  {
    key: 'RESPONSE_LETTER',
    value: 'Carta resposta',
    text: 'Carta resposta',
  },
  {
    key: 'RENT_CONTRACT',
    value: 'Contrato de locação',
    text: 'Contrato de locação',
  },
  {
    key: 'PORTO_ESSENCIAL_APROVAL_LETTER_BUDGETS',
    value: 'Cotação Porto Essencial',
    text: 'Cotação Porto Essencial',
  },
  {
    key: 'PORTO_ESSENCIAL_APPROVAL_OFFERS',
    value: 'Cotação condições',
    text: 'Cotação condições',
  },
  {
    key: 'QUOTE_DOCUMENT',
    value: 'Cotação',
    text: 'Cotação',
  },
  {
    key: 'CORRECTION_ENDORSEMENT',
    value: 'Endosso de correção',
    text: 'Endosso de correção',
  },
];

export const BondInsuranceFilesCancelContext = [
  {
    key: 'OTHER',
    value: 'Outros',
    text: 'Outros',
  },
  {
    key: 'PROPERTY_PURCHASE_TERM',
    value: 'Termo compra do imóvel',
    text: 'Termo compra do imóvel',
  },
  {
    key: 'LEASE_ADVANCE_TERM',
    value: 'Termo de antecipação de locação',
    text: 'Termo de antecipação de locação',
  },
  {
    key: 'LEASE_WITHDRAWL_TERM',
    value: 'Termo de desistência de locação',
    text: 'Termo de desistência de locação',
  },
  {
    key: 'DELIVERY_KEYS_TERM',
    value: 'Termo de Entrega de Chaves com Inexistência de débitos',
    text: 'Termo de Entrega de Chaves com Inexistência de débitos',
  },
  {
    key: 'TENANT_CHANGE_TERM',
    value: 'Termo de troca de locatário',
    text: 'Termo de troca de locatário',
  },
  {
    key: 'INSURANCE_CHANGE_TERM',
    value: 'Termo cancelamento de troca de seguradora',
    text: 'Termo cancelamento de troca de seguradora',
  },
  {
    key: 'DUPLICATION_POLICY_TERM',
    value: 'Termo cancelamento duplicidade de apólice',
    text: 'Termo cancelamento duplicidade de apólice',
  },
  {
    key: 'CHANGE_WARRANTY_TERM',
    value: 'Termo cancelamento troca de garantia',
    text: 'Termo cancelamento troca de garantia',
  },
  {
    key: 'NO_EXISTENCE_DEBTS_TERM',
    value: 'Termo de inexistência de débitos',
    text: 'Termo de inexistência de débitos',
  },
  {
    key: 'TERMINATION_TERM',
    value: 'Termo de rescisão',
    text: 'Termo de rescisão',
  },
  {
    key: 'CANCELATION_ENDORSEMENT',
    value: 'Endosso de cancelamento',
    text: 'Endosso de cancelamento',
  },
  {
    key: 'PAYMENT_VOUCHER',
    value: 'Comprovante de pagamento',
    text: 'Comprovante de pagamento',
  }
];

const FilesAllContext = [
  {
    key: 'POLICY',
    value: 'Apólice',
    text: 'Apólice'
  },
  {
    key: 'BALANCE_SHEET',
    value: 'Balancete',
    text: 'Balancete'
  },
  {
    key: 'BALANCE_SHEET_LAST_3_YEARS_COMPANY_DRE',
    value: 'Balanço patrimonial últimos 3 anos da empresa com DRE',
    text: 'Balanço patrimonial últimos 3 anos da empresa com DRE'
  },
  {
    key: 'PORTO_ESSENCIAL_BUDGETS_OFFERS',
    value: 'Carta de aprovação condições',
    text: 'Carta de aprovação condições'
  },
  {
    key: 'PORTO_ESSENCIAL_APROVAL_LETTER',
    value: 'Carta de Aprovação Porto Essencial',
    text: 'Carta de Aprovação Porto Essencial'
  },
  {
    key: 'RESPONSE_LETTER',
    value: 'Carta resposta',
    text: 'Carta resposta'
  },
  {
    key: 'BROKERAGE_TRANSFER_LETTER',
    value: 'Carta de tranferência de corretagem',
    text: 'Carta de tranferência de corretagem'
  },
  {
    key: 'PAYMENT_VOUCHER',
    value: 'Comprovante de pagamento',
    text: 'Comprovante de pagamento'
  },
  {
    key: 'RENT_CONTRACT',
    value: 'Contrato de locação',
    text: 'Contrato de locação'
  },
  {
    key: 'SOCIAL_CONTRACT',
    value: 'Contrato social',
    text: 'Contrato social'
  },
  {
    key: 'PORTO_ESSENCIAL_APPROVAL_OFFERS',
    value: 'Cotação condições',
    text: 'Cotação condições'
  },
  {
    key: 'PORTO_ESSENCIAL_APROVAL_LETTER_BUDGETS',
    value: 'Cotação Porto Essencial',
    text: 'Cotação Porto Essencial'
  },
  {
    key: 'QUOTE_DOCUMENT',
    value: 'Cotação',
    text: 'Cotação'
  },
  {
    key: 'LESSOR_RG_CNH',
    value: 'Documento de identificação do locador',
    text: 'Documento de identificação do locador'
  },
  {
    key: 'TENANT_RG_CNH',
    value: 'Documento de identificação do locatário',
    text: 'Documento de identificação do locatário'
  },
  {
    key: 'CANCELATION_ENDORSEMENT',
    value: 'Endosso de cancelamento',
    text: 'Endosso de cancelamento'
  },
  {
    key: 'CORRECTION_ENDORSEMENT',
    value: 'Endosso de correção',
    text: 'Endosso de correção'
  },
  {
    key: 'BANK_STATEMENTS_LAST_3_MONTHS',
    value: 'Extratos bancários ultimos 3 meses',
    text: 'Extratos bancários ultimos 3 meses'
  },
  {
    key: 'COMPLEMENTARY_FORM',
    value: 'Formulário complementar',
    text: 'Formulário complementar'
  },
  {
    key: 'PGDAS_GUIDE_LAST_6_MONTHS_PAYMENT',
    value: 'Guia PGDAS dos últimos 6 meses com autenticação de pagamento',
    text: 'Guia PGDAS dos últimos 6 meses com autenticação de pagamento'
  },
  {
    key: 'PAY_SLIP_PAYCHECK',
    value: 'Holerite/Contra-cheque',
    text: 'Holerite/Contra-cheque'
  },
  {
    key: 'INCOME_TAX_WITH_DELIVERY_RECEIPT',
    value: 'Imposto de renda com Recibo de entrega',
    text: 'Imposto de renda com Recibo de entrega'
  },
  {
    key: 'OTHER',
    value: 'Outros',
    text: 'Outros'
  },
  {
    key: 'BILLING_REPORT',
    value: 'Relatório de faturamento',
    text: 'Relatório de faturamento'
  },
  {
    key: 'INSURANCE_CHANGE_TERM',
    value: 'Termo cancelamento de troca de seguradora',
    text: 'Termo cancelamento de troca de seguradora'
  },
  {
    key: 'DUPLICATION_POLICY_TERM',
    value: 'Termo cancelamento duplicidade de apólice',
    text: 'Termo cancelamento duplicidade de apólice'
  },
  {
    key: 'CHANGE_WARRANTY_TERM',
    value: 'Termo cancelamento troca de garantia',
    text: 'Termo cancelamento troca de garantia'
  },
  {
    key: 'PROPERTY_PURCHASE_TERM',
    value: 'Termo compra do imóvel',
    text: 'Termo compra do imóvel'
  },
  {
    key: 'LEASE_ADVANCE_TERM',
    value: 'Termo de antecipação de locação',
    text: 'Termo de antecipação de locação'
  },
  {
    key: 'LEASE_WITHDRAWL_TERM',
    value: 'Termo de desistência de locação',
    text: 'Termo de desistência de locação'
  },
  {
    key: 'DELIVERY_KEYS_TERM',
    value: 'Termo de Entrega de Chaves com Inexistência de débitos',
    text: 'Termo de Entrega de Chaves com Inexistência de débitos'
  },
  {
    key: 'NO_EXISTENCE_DEBTS_TERM',
    value: 'Termo de inexistência de débitos',
    text: 'Termo de inexistência de débitos',
  },
  {
    key: 'TERMINATION_TERM',
    value: 'Termo de rescisão',
    text: 'Termo de rescisão'
  },
  {
    key: 'TENANT_CHANGE_TERM',
    value: 'Termo de troca de locatário',
    text: 'Termo de troca de locatário'
  }
];

export const getFilesTypesByContext = (context: string | undefined): any[] => {
  switch (context) {
    case 'analysis':
      return BondInsuranceFilesAnalysisContext;
    case 'policy':
      return BondInsuranceFilesPolicyContext;
    case 'canceled':
      return BondInsuranceFilesCancelContext;
    case 'all':
      return FilesAllContext;
    default:
      return [];
  }
};
